import React from 'react';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';

import { formatDateByCountry } from '../../../../helpers/dateAndTimeHelper';
import {
  getRegistrationFeeChargeKey,
  RegistrationFeeChargeKey,
  registrationFeeChargeKey
} from '../../constants';

interface RegistrationFeeAttempt {
  chargedAt: string;
  reason?: string | null;
  skipped?: boolean;
  success?: boolean;
}

interface RegistrationFeeHistoryProps {
  attempts?: RegistrationFeeAttempt[];
  organizationCountry?: string;
}

const i18nBase = 'applications.template.page.partOne.registration-fee.history';

const outcomeKeys: Record<RegistrationFeeChargeKey, string> = {
  [registrationFeeChargeKey.CHARGED]: 'paid',
  [registrationFeeChargeKey.FAILED]: 'failed',
  [registrationFeeChargeKey.SKIPPED]: 'skipped'
};

// The date follows the organisation's format like the Payment line above it; the time is local to the viewer.
const formatAttemptTime = (chargedAt: string, country?: string) => {
  const local = moment.utc(chargedAt).local();
  return `${formatDateByCountry(local.toDate(), country ?? '')}, ${local.format('h:mm A')}`;
};

const RegistrationFeeHistory = ({
  attempts = [],
  organizationCountry
}: RegistrationFeeHistoryProps) => {
  if (!attempts.length) {
    return null;
  }

  return (
    <details className="registration-fee-history">
      <summary>{I18n.t(`${i18nBase}.title`)}</summary>
      <table>
        <thead>
          <tr>
            <th scope="col">{I18n.t(`${i18nBase}.date`)}</th>
            <th scope="col">{I18n.t(`${i18nBase}.outcome`)}</th>
          </tr>
        </thead>
        <tbody>
          {attempts.map((attempt, index) => (
            <tr key={`${index}-${attempt.chargedAt}`}>
              <td>
                {formatAttemptTime(attempt.chargedAt, organizationCountry)}
              </td>
              <td>
                {I18n.t(
                  `${i18nBase}.${outcomeKeys[getRegistrationFeeChargeKey(attempt)]}`
                )}
                {attempt.reason && (
                  <div className="registration-fee-history-reason">
                    {I18n.t(`${i18nBase}.reason`, { reason: attempt.reason })}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  );
};

export default RegistrationFeeHistory;
